<button :class="[user.name_color, 'chat-user']" v-html="displayedName" @click="onClick"></button>